import { createAsyncThunk } from "@reduxjs/toolkit";
import tierApi from "./api";
import { message } from "antd";

export const doGetTiers = createAsyncThunk(
  "tiers/getTiers",
  async (_, { rejectWithValue }) => {
    try {
      const data = await tierApi.getTiers();
      return { data };
    } catch (error) {
      message.error("Failed to load tiers");
      return rejectWithValue(error.response?.data);
    }
  }
);

export const doGetTier = createAsyncThunk(
  "tiers/getTier",
  async (id, { rejectWithValue }) => {
    try {
      const data = await tierApi.getTier(id);
      return { data };
    } catch (error) {
      message.error("Failed to load tier");
      return rejectWithValue(error.response?.data);
    }
  }
);

export const doCreateTier = createAsyncThunk(
  "tiers/createTier",
  async (tierData, { rejectWithValue }) => {
    try {
      const data = await tierApi.createTier(tierData);
      message.success("Tier created successfully");
      return { data };
    } catch (error) {
      message.error(error.response?.data?.message || "Failed to create tier");
      return rejectWithValue(error.response?.data);
    }
  }
);

export const doUpdateTier = createAsyncThunk(
  "tiers/updateTier",
  async ({ id, tierData }, { rejectWithValue }) => {
    try {
      const data = await tierApi.updateTier(id, tierData);
      message.success("Tier updated successfully");
      return { data };
    } catch (error) {
      message.error(error.response?.data?.message || "Failed to update tier");
      return rejectWithValue(error.response?.data);
    }
  }
);

export const doDeleteTier = createAsyncThunk(
  "tiers/deleteTier",
  async (id, { rejectWithValue }) => {
    try {
      await tierApi.deleteTier(id);
      message.success("Tier deleted successfully");
      return { id };
    } catch (error) {
      message.error(error.response?.data?.message || "Failed to delete tier");
      return rejectWithValue(error.response?.data);
    }
  }
);
